/**
 * @generated SignedSource<<263b60d5a25b1a3866257df6608a7bb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextFieldTranslateButton_from$data = {
  readonly locale: Locale;
  readonly " $fragmentSpreads": FragmentRefs<"LanguageIndicator_language">;
  readonly " $fragmentType": "TranslatableTextFieldTranslateButton_from";
};
export type TranslatableTextFieldTranslateButton_from$key = {
  readonly " $data"?: TranslatableTextFieldTranslateButton_from$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_from">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranslatableTextFieldTranslateButton_from",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LanguageIndicator_language"
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "a6571f81e657f03dff0a64ee311376ad";

export default node;
